import Breadcrumb from '@/components/feature/Breadcrumb';
import FeedbackForm from '@/pages/about/components/FeedbackForm';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

const missions = [
  {
    icon: 'ri-focus-3-line',
    title: '我们的使命',
    desc: '用清晰的分类与高效的检索，帮助娱乐爱好者更快找到关心的黑料与资讯。',
    tone: 'primary',
  },
  {
    icon: 'ri-user-heart-line',
    title: '我们的定位',
    desc: '面向年轻及中年网民，聚合明星内幕、绯闻爆料、影视综艺动态与娱乐热点。',
    tone: 'accent',
  },
  {
    icon: 'ri-shield-check-line',
    title: '内容原则',
    desc: '所有内容均为虚构演示，抵制谣言与隐私侵犯，倡导理性吃瓜、健康娱乐。',
    tone: 'secondary',
  },
];

const toneMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-600',
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-800',
};

const team = [
  {
    name: '陈默',
    role: '内容总监',
    desc: '把关内容方向与选题标准，坚持"有料但不越界"。',
    avatar:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20of%20a%20confident%20middle%20aged%20Chinese%20man%20in%20a%20dark%20shirt%20against%20a%20dark%20charcoal%20studio%20background%20with%20a%20subtle%20red%20rim%20light%2C%20dramatic%20cinematic%20lighting%2C%20minimal%20modern%20magazine%20aesthetic%2C%20high%20detail&width=400&height=400&seq=team-1&orientation=squarish',
  },
  {
    name: '沈知',
    role: '娱乐主编',
    desc: '深耕娱乐行业多年，擅长把复杂的爆料讲清楚。',
    avatar:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20of%20an%20elegant%20young%20Chinese%20woman%20with%20short%20hair%20against%20a%20dark%20charcoal%20studio%20background%20with%20a%20soft%20red%20rim%20light%2C%20dramatic%20cinematic%20lighting%2C%20minimal%20modern%20magazine%20aesthetic%2C%20high%20detail&width=400&height=400&seq=team-2&orientation=squarish',
  },
  {
    name: '林可',
    role: '资深编辑',
    desc: '负责分类整理与标签体系，让每一条内容各归其位。',
    avatar:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20of%20a%20friendly%20young%20Chinese%20woman%20with%20glasses%20against%20a%20dark%20charcoal%20studio%20background%20with%20warm%20amber%20accent%20light%2C%20dramatic%20cinematic%20lighting%2C%20minimal%20modern%20magazine%20aesthetic%2C%20high%20detail&width=400&height=400&seq=team-3&orientation=squarish',
  },
  {
    name: '周野',
    role: '运营负责人',
    desc: '关注用户体验与内容传播，持续优化浏览与检索体验。',
    avatar:
      'https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20of%20a%20cheerful%20young%20Chinese%20man%20in%20a%20light%20jacket%20against%20a%20dark%20charcoal%20studio%20background%20with%20a%20red%20rim%20light%2C%20dramatic%20cinematic%20lighting%2C%20minimal%20modern%20magazine%20aesthetic%2C%20high%20detail&width=400&height=400&seq=team-4&orientation=squarish',
  },
];

export default function AboutPage() {
  useDocumentMeta(
    '关于我们 - 91黑料娱乐黑料爆料平台',
    '了解91黑料平台的定位、团队与联系方式，并留下你的反馈建议，共同打造更好的娱乐黑料爆料平台。',
  );

  return (
    <div className="w-full">
      <div className="max-w-content mx-auto px-4 md:px-6 pt-6 md:pt-8">
        <Breadcrumb items={[{ label: '关于我们' }]} />
      </div>

      <section className="bg-foreground-950 text-background-50 mt-5 md:mt-6">
        <div className="max-w-content mx-auto px-4 md:px-6 py-12 md:py-16">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium mb-4">
            <i className="ri-megaphone-line"></i> 关于 91黑料
          </span>
          <h1 className="text-3xl md:text-4xl font-black leading-tight max-w-3xl">
            让每一次吃瓜，都有据可循
          </h1>
          <p className="text-sm md:text-base text-background-300 leading-relaxed mt-5 max-w-3xl">
            91黑料是一个聚焦娱乐黑料爆料与娱乐资讯的聚合型门户。我们把散落在各处的明星内幕、影视综艺动态与娱乐热点，
            用清晰的分类和标签重新组织，配合关键词搜索与多维筛选，帮助你用更少的时间，掌握更全的娱乐圈风向。
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 max-w-3xl">
            {[
              { value: '24/7', label: '全天候更新' },
              { value: '5', label: '内容分类' },
              { value: '8+', label: '明星专题' },
              { value: '100%', label: '虚构演示内容' },
            ].map((s) => (
              <div key={s.label} className="border-l-2 border-primary-500 pl-3">
                <p className="text-xl md:text-2xl font-black font-label text-background-50">{s.value}</p>
                <p className="text-xs text-background-400 mt-1">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="max-w-content mx-auto px-4 md:px-6 py-10 md:py-14 space-y-12 md:space-y-16">
        <section className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {missions.map((m) => (
            <div key={m.title} className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
              <span className={`w-12 h-12 rounded-lg flex items-center justify-center mb-4 ${toneMap[m.tone]}`}>
                <i className={`${m.icon} text-2xl`}></i>
              </span>
              <h2 className="text-lg font-black text-foreground-950">{m.title}</h2>
              <p className="text-sm text-foreground-600 leading-relaxed mt-2">{m.desc}</p>
            </div>
          ))}
        </section>

        <section>
          <div className="flex items-center gap-2.5 mb-6">
            <span className="w-9 h-9 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center">
              <i className="ri-team-line text-xl"></i>
            </span>
            <div>
              <h2 className="text-lg md:text-xl font-black text-foreground-950">团队介绍</h2>
              <p className="text-xs md:text-sm text-foreground-500 mt-0.5">一群热爱娱乐资讯的内容人</p>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
            {team.map((member) => (
              <div
                key={member.name}
                className="bg-background-50 border border-background-200 rounded-lg overflow-hidden"
              >
                <div className="w-full aspect-square bg-background-100">
                  <img
                    src={member.avatar}
                    alt={member.name}
                    title={`${member.name}-91黑料团队`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-4">
                  <div className="flex items-center gap-2">
                    <h3 className="text-base font-black text-foreground-950">{member.name}</h3>
                    <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 text-[11px]">
                      {member.role}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-600 mt-2 leading-relaxed">{member.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-6">
              <span className="w-9 h-9 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center">
                <i className="ri-contacts-book-2-line text-xl"></i>
              </span>
              <div>
                <h2 className="text-lg md:text-xl font-black text-foreground-950">联系方式</h2>
                <p className="text-xs md:text-sm text-foreground-500 mt-0.5">欢迎随时与我们取得联系</p>
              </div>
            </div>

            <div className="space-y-4">
              {[
                { icon: 'ri-mail-send-line', label: '合作邮箱', value: 'contact@91heiliao.example.com' },
                { icon: 'ri-weibo-line', label: '官方微博', value: '@91黑料爆料平台' },
                { icon: 'ri-map-pin-line', label: '办公地址', value: '演示地址 · 虚拟内容中心 A 座' },
              ].map((item) => (
                <div
                  key={item.label}
                  className="flex items-center gap-4 p-4 bg-background-50 border border-background-200 rounded-lg"
                >
                  <span className="w-11 h-11 rounded-lg bg-background-100 text-primary-600 flex items-center justify-center shrink-0">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <div className="min-w-0">
                    <p className="text-xs text-foreground-500">{item.label}</p>
                    <p className="text-sm font-medium text-foreground-900 truncate">{item.value}</p>
                  </div>
                </div>
              ))}

              <div className="flex items-center gap-4 p-4 bg-background-50 border border-background-200 rounded-lg">
                <span className="w-20 h-20 rounded-lg bg-background-100 text-secondary-700 flex items-center justify-center shrink-0 border border-background-200">
                  <i className="ri-qr-code-line text-5xl"></i>
                </span>
                <div>
                  <p className="text-xs text-foreground-500">微信公众号</p>
                  <p className="text-sm font-medium text-foreground-900 mt-0.5">91黑料</p>
                  <p className="text-xs text-foreground-500 mt-1">扫码关注，第一时间获取最新爆料</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="flex items-center gap-2.5 mb-6">
              <span className="w-9 h-9 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center">
                <i className="ri-feedback-line text-xl"></i>
              </span>
              <div>
                <h2 className="text-lg md:text-xl font-black text-foreground-950">意见反馈</h2>
                <p className="text-xs md:text-sm text-foreground-500 mt-0.5">你的每一条建议我们都会认真阅读</p>
              </div>
            </div>
            <div className="bg-background-50 border border-background-200 rounded-lg p-5 md:p-6">
              <FeedbackForm />
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}